import { Selector } from 'react-redux';
import { RootState } from '../../redux/root-reducer';
import { createSelector } from 'reselect';
import { IContestAward, IReedemableCode, IUserSummary } from '../../types/global/helper';
import { IHost } from '../../redux/discovery/types';
import { IJuryDuties, IScoreBoardResponse } from '../../redux/jury/types';
import { IAwardCategory } from '../../redux/contest/types';
import { IUsersDashboardData } from '../../redux/user/types';

export const userSearchSelector: Selector<RootState, IUserSummary[]> = createSelector(
    (state: RootState) => state.user,
    user => user.userSearchResult || [],
);
export const searchingUserSearchSelector: Selector<RootState, boolean | undefined> = createSelector(
    (state: RootState) => state.user,
    user => user.searchingUser,
);
export const testUsersSelector: Selector<RootState, IUserSummary[]> = createSelector(
    (state: RootState) => state.user,
    user => user.testUsers,
);

export const dashboardDataSelector: Selector<RootState, IUsersDashboardData> = createSelector(
    (state: RootState) => state.user,
    user => user.dashboardData,
);
export const dashboardDataLoadingSelector: Selector<RootState, boolean> = createSelector(
    (state: RootState) => state.user,
    user => user.gettingDashboardData,
);
export const hostSearchSelector: Selector<RootState, IHost[] | undefined> = createSelector(
    (state: RootState) => state.contest,
    contest => contest.hostSearchResult,
);
export const searchingHostSelector: Selector<RootState, boolean | undefined> = createSelector(
    (state: RootState) => state.contest,
    contest => contest.searchingHost,
);

export const partnerSearchSelector: Selector<RootState, IHost[] | undefined> = createSelector(
    (state: RootState) => state.contest,
    contest => contest.partnerSearchResult,
);
export const searchingPartnerSelector: Selector<RootState, boolean | undefined> = createSelector(
    (state: RootState) => state.contest,
    contest => contest.searchingPartner,
);

export const alreadyAssignedRedeemableCodesSelector: Selector<RootState, IReedemableCode[]> = createSelector(
    (state: RootState) => state.contest,
    contest => contest.redeemableCodes,
);

export const fetchingAssignedCodesSelector: Selector<RootState, boolean | undefined> = createSelector(
    (state: RootState) => state.contest,
    contest => contest.fetchingAssignedCodes,
);

export const sendingRedeemableCodesSelector: Selector<RootState, boolean | undefined> = createSelector(
    (state: RootState) => state.contest,
    contest => contest.assigningCode,
);

export const scoreBoardSelector: Selector<RootState, IScoreBoardResponse> = createSelector(
    (state: RootState) => state.jury,
    jury => jury.scoreBoard as IScoreBoardResponse,
);
export const jurySelector: Selector<RootState, IJuryDuties[]> = createSelector(
    (state: RootState) => state.jury,
    jury => jury.selectedJuries,
);

export const loadingSelector: Selector<RootState, boolean> = createSelector(
    (state: RootState) => state.jury,
    jury => jury.loading,
);

export const juryMessageSelector: Selector<RootState, string | undefined> = createSelector(
    (state: RootState) => state.jury,
    jury => jury.juryMessage,
);

export const fetchingSelector: Selector<RootState, { fetchingScoreBoard: boolean; fetchingJudges: boolean }> =
    createSelector(
        (state: RootState) => state.jury,
        jury => ({
            fetchingJudges: jury.gettingJurorForContest || false,
            fetchingScoreBoard: jury.gettingScoreBoard || false,
        }),
    );

export const contestAwardCategoryAndAwardsSelector: Selector<
    RootState,
    { contestAwardCategory: IAwardCategory[]; contestAward: IContestAward[] }
> = createSelector(
    (state: RootState) => state.contest,
    contest => ({
        contestAward: contest.selectedContestPrizeWinners,
        contestAwardCategory: contest.selectedContestAwardCategories,
    }),
);
